export default {
  hubSpotCompanies: [],
  hubSpotCompany: undefined,
};
